module.exports = __webpack_public_path__ + "weather.59821f40c03de5dd7efe.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/weather/webfont/weather.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/weather/webfont/weather.svg
// module chunks = styles